document.addEventListener('alpine:init', () => {
  window.Alpine.data('infiniteScroll', ({ direction, speedRatio, itemCount }) => ({
    animated: false,
    duration: 0,
    resizeObserver: null,
    scrollerWidth: 0,
    originalSpacer: 0,
    direction,
    speedRatio,
    itemCount,

    init() {
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return

      this.animated = true

      this.$nextTick(() => {
        this.originalSpacer = parseInt(
          getComputedStyle(this.$root).getPropertyValue('--spacer'),
          10,
        )

        this.animate()
        this.initResizeObserver()
      })

      window.addEventListener('infiniteScroll', () => {
        this.$nextTick(() => {
          document.fonts.ready.then(() => {
            this.animate()
            this.computeGap()
          })
        })
      })
    },

    initResizeObserver() {
      // Prevents multiple ResizeObservers from being created
      // if init is called multiple times for any reason.
      if (this.resizeObserver) return

      this.resizeObserver = new ResizeObserver(() => {
        this.computeGap()
      })

      this.resizeObserver.observe(this.$refs.scrollerWrapper)
    },

    animate() {
      const allChildren = Array.from(this.$refs.scroller.children)
      allChildren
        .filter((el) => el.dataset && el.dataset.duplicate === 'true')
        .forEach((el) => el.remove())

      const scrollerContent = Array.from(this.$refs.scroller.children)
      const wrapperWidth = this.$refs.scrollerWrapper.offsetWidth

      if (this.$refs.scroller.offsetWidth < wrapperWidth * 3) {
        while (this.$refs.scroller.offsetWidth < wrapperWidth * 3) {
          scrollerContent.forEach((item) => {
            const duplicatedItem = item.cloneNode(true)
            duplicatedItem.setAttribute('aria-hidden', true)
            duplicatedItem.dataset.duplicate = 'true'
            this.$refs.scroller.appendChild(duplicatedItem)
          })
        }
      } else {
        scrollerContent.forEach((item) => {
          const duplicatedItem = item.cloneNode(true)
          duplicatedItem.setAttribute('aria-hidden', true)
          duplicatedItem.dataset.duplicate = 'true'
          this.$refs.scroller.appendChild(duplicatedItem)
        })
      }

      this.scrollerWidth = this.$refs.scroller.offsetWidth
    },

    computeGap() {
      this.$root.style.removeProperty('--scroller-spacer')

      const wrapperWidth = this.$refs.scrollerWrapper.offsetWidth
      const offsetLeft = parseInt(
        getComputedStyle(this.$refs.scrollerWrapper).getPropertyValue('padding-left'),
        10,
      )

      if (this.scrollerWidth + this.originalSpacer + offsetLeft < wrapperWidth) {
        const gap = (wrapperWidth - this.scrollerWidth + offsetLeft) / this.itemCount
        this.$root.style.setProperty('--scroller-spacer', `${gap}px`)
      }

      this.duration = (this.$refs.scroller.offsetWidth * 5) / this.speedRatio
    },
  }))
})